<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Products/TerminationRules/Form'
import { route } from '~@/Composables/route'

defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

function submitData (form) {
    form.post(route('products.termination-rules.store'))
}
</script>
